import React, { useEffect } from 'react';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { LeadProvider } from './contexts/LeadContext';
import { usePageTracking } from './hooks/usePageTracking';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { MeetTheQueens } from './components/MeetTheQueens';
import { QueenExperience } from './components/QueenExperience';
import { TradeIn } from './components/TradeIn';
import { LeadForm } from './components/LeadForm/LeadForm';
import { HowItWorks } from './components/HowItWorks';
import { Faq } from './components/Faq';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppCTA } from './components/WhatsAppCTA';
import { QueenPickerModal } from './components/QueenPickerModal';
import { SectionDivider } from './components/SectionDivider';

/**
 * TEMPORARY: the site is live with placeholder photography and copy.
 * REMOVE THIS BEFORE LAUNCH so the page can be indexed.
 */
function useNoIndexMeta() {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    meta.setAttribute('data-remove-before-launch', 'true');
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
}
function Landing() {
  const {
    t
  } = useLanguage();
  usePageTracking();
  useNoIndexMeta();
  return <div className="w-full overflow-x-hidden bg-white" data-id="element-0" data-mp="33m5e4aq9pybi">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[70] focus:bg-ink focus:px-4 focus:py-2 focus:text-sm focus:font-bold focus:text-white" data-id="element-1" data-mp="33ork45xig5rm">
        {t('nav.skip')}
      </a>
      <Header data-id="element-2" data-mp="nuhged3fk1rn" />
      <main id="main" data-id="element-3" data-mp="nuraocvicv35">
        <Hero data-id="element-4" data-mp="nxn71wrpjbph" />
        <TrustBar data-id="element-5" data-mp="suncc5gqgafj" />
        <MeetTheQueens data-id="element-6" data-mp="su45bjsmf6ga" />
        <SectionDivider data-id="element-7" data-mp="stkok6epio3u" />
        <QueenExperience data-id="element-8" data-mp="sssrer5goibg" />
        <TradeIn data-id="element-9" data-mp="36hxla6f4y2t" />
        <LeadForm data-id="element-10" data-mp="35ypel6klo1z" />
        <HowItWorks data-id="element-11" data-mp="35gld2do25ji" />
        <SectionDivider data-id="element-12" data-mp="34x2njg6zd4f" />
        <Faq data-id="element-13" data-mp="38b50rouvmbv" />
        <FinalCTA data-id="element-14" data-mp="3uct0zcywiaxb" />
      </main>
      <Footer data-id="element-15" data-mp="3ubrg6gs32a2e" />
      <WhatsAppCTA data-id="element-16" data-mp="3ubzvsgflbtha" />
      <QueenPickerModal data-id="element-17" data-mp="3uevrrz7vo833" />
    </div>;
}
export function App() {
  return <LanguageProvider data-id="element-18" data-mp="d3crffrqyaar">
      <LeadProvider data-id="element-19" data-mp="d2l8b4fc651d">
        <Landing data-id="element-20" data-mp="85l1granwy97" />
      </LeadProvider>
    </LanguageProvider>;
}